export { default as Translate } from './Translate';
